import React, { Component } from 'react'

class ExamTimer extends Component {

    constructor(props){
        super(props);
        this.state = {
            time: 0,
            isOn: false,
            start: 0
        }
    }

    componentDidUpdate() {
        if(this.props.isCounting && !this.state.isOn) {
            this.start()
        } else if(this.props.isCounting === false && this.state.isOn) {
            this.stop()
        }
    }

    componentWillUnmount() {
        if(this.timer) {
            clearInterval(this.timer)
        }
    }

    start() {
        this.setState({
            isOn: true,
            start: this.props.start
        });

        this.timer = setInterval(() => this.setState({
            time: Date.now() - this.props.start
        }), 1000);
    }

    stop() {
        this.setState({isOn: false});
        this.timer && clearInterval(this.timer)
    }

    reset() {
        this.setState({time: 0, isOn: false})
    }

    msToTimer(milliseconds) {
        let seconds = Math.trunc((milliseconds / 1000) % 60);
        let minutes = Math.trunc(((milliseconds / (1000*60)) % 60));
        let hours   = Math.trunc(((milliseconds / (1000*60*60)) % 24));

        return {
            hours: ('00' + hours).slice(-2),
            minutes: ('00' + minutes).slice(-2),
            seconds: ('00' + seconds).slice(-2),
        }
    }

    render() {
        let { hours, minutes, seconds } = this.msToTimer(this.state.time)
        return (
            <div className="timer-container">
                <div className="grid-x grid-margin-x align-middle">
                    <div className="shrink cell">
                        <i className="icon-tempo" />
                    </div>
                    <div className="auto cell">
                        <div className="timer-container__timer">
                            { hours }
                            <span>:</span>
                            { minutes }
                            <span>:</span>
                            { seconds }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export { ExamTimer }
